var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
    if (!selectedStore) return;
    const storeId = selectedStore.storeID;
    
    if (storeId === 3493) {
        picker.set('disable', [
                        { from: [2020, 8, 10], to: [2035, 5, 14] },                            
                        [2025, 7, 9, 'inverted'],
                        [2025, 7, 23, 'inverted'],
                        [2025, 8, 6, 'inverted'],
                        [2025, 8, 20, 'inverted'],
                        [2025, 9, 4, 'inverted'],
                        [2025, 9, 18, 'inverted'],
                    ]);
    } else if (storeId === 1384) {
        picker.set('disable', [
                        { from: [2020, 8, 10], to: [2035, 5, 14] },                            
                        [2025, 7, 2, 'inverted'],
                        [2025, 7, 16, 'inverted'],
                        [2025, 7, 30, 'inverted'],
                        [2025, 8, 13, 'inverted'],
                        [2025, 8, 27, 'inverted'],
                        [2025, 9, 11, 'inverted'],
                        [2025, 9, 25, 'inverted'],
                    ]);
        picker.set('min', 5);                   
        picker.set('max', 200);                   
    } else if (storeId === 6587) {
        picker.set('disable', [
                        { from: [2020, 8, 10], to: [2035, 5, 14] },                            
                        [2025, 7, 10, 'inverted'],
                        [2025, 7, 24, 'inverted'],
                        [2025, 8, 7, 'inverted'],
                        [2025, 8, 21, 'inverted'],
                        [2025, 9, 5, 'inverted'],
                        [2025, 9, 19, 'inverted'],
                        
                    ]);
        //picker.set('min', 5);                   
        picker.set('max', 200);                   
    } else if (storeId === 3281) {
        picker.set('disable', [
                        { from: [2020, 8, 10], to: [2035, 5, 14] },                            
                        [2025, 7, 3, 'inverted'],
                        [2025, 7, 17, 'inverted'],
                        [2025, 7, 31, 'inverted'],
                        [2025, 8, 14, 'inverted'],
                        [2025, 8, 28, 'inverted'],
                        [2025, 9, 12, 'inverted'],
                        [2025, 9, 26, 'inverted'],                        
                    ]);
        picker.set('min', 5);                   
        picker.set('max', 200);                   
    }

     else {
        picker.set('disable', blackoutdatesCollection);
    }
//   if (specialProduct === true) {
//   	picker.set('disable', [true, 
//         { from: [2020, 8, 10], to: [2020, 8, 23] }, 
//         { from: [2020, 9, 13], to: [2022, 9, 7] }
//     ]);
//     picker.set('max', 100);   
//   }	
  
  
}